import { getService } from 'data/function';
import { ChecklistModal } from 'modules/ui';
export class ChecklistModalProcessor {
    static get ModalService() {
        return getService('ModalService');
    }
    static async process({ message, trackingProperties, source, }) {
        try {
            const modal = await ChecklistModalProcessor.ModalService.showModal(ChecklistModal(message.content));
            const modalResponse = await modal.close;
            const messageResponse = {
                response: modalResponse,
                trackingProperties,
            };
            source.postMessage(messageResponse, '*');
        }
        catch (e) {
            const errorResponse = {
                error: e.toString(),
                trackingProperties,
            };
            source.postMessage(errorResponse, '*');
        }
    }
}
